import { render, staticRenderFns } from "./DeleteRole.vue?vue&type=template&id=1dce41f9&"
import script from "./DeleteRole.vue?vue&type=script&lang=ts&"
export * from "./DeleteRole.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports